import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Build a backend file URL for a storage path
export const fileUrl = (path) => `${API}/files/${path}`;

// Build an absolute backend URL from an API-relative path (e.g. /api/overlays/...)
export const backendUrl = (path) => `${BACKEND_URL}${path}`;
